module.exports = __webpack_public_path__ + "img/mobileapplication7.4231c909.png";